import { Component, Input, ViewChild } from '@angular/core';
import { PopoverService } from 'app/core/services/popover.service';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
let id =1;
@Component({
  selector: 'app-party-signup-popover',
  standalone: true,
  imports: [MdbPopoverModule],
  templateUrl: './party-signup-popover.component.html',
  styleUrl: './party-signup-popover.component.scss'
})
export class PartySignupPopoverComponent {
@ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() campaignId: string = '';

  private _id = id++;
  get id() {
    return `PartySignupPopover_${this._id}`;
  }

  constructor(
    private popoverService: PopoverService,
  ) {}

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
    const self = this;

    window["$"](window).one('click', function() {
      self.popover.hide()
      delete self.popoverService.list[self.id];
    });
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  onDownloadBidSheet (type: number) {
    let subtitle = ''
    switch (type) {
      case 3:
        subtitle = 'This sheet can be used for taking offline paper bids at your event. Use the download button to download.'
        break;
      case 4:
        subtitle = 'This sheet can be used for taking online paper bids at your event. Use the download button to download.'
        break;
      default:
        subtitle = 'Use the download button to download.'
        break;
    }

    window["orgMain"].getBidSheet(
      type, 
      this.campaignId,
      "Preview and download bid sheet",
      subtitle
    )
  }
}
